module.exports = __webpack_public_path__ + "9e3b93aa7c3988a3439ecd99017aec4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic-icon.png
// module id = 255
// module chunks = 1